<template>
  <div class="about-container">
    <div class="contactusClass">
      <table></table>
      <div class="bodyBox">
        <companyProfile />
      </div>
    </div>
    <div class="companyGood-box">
      <div class="bodyBox">
        <companyGood/>
      </div>      
    </div>
    <!-- <div class="swiperIntroduction-box">
      <div class="bodyBox">
        <swiperIntroduction/>
      </div>      
    </div> -->
    <!-- <div class="teamIntroduction-box">
      <div class="bodyBox">
        <teamIntroduction/>
      </div>      
    </div> -->
    <div class="contactUsComponent-class" ref="cc">
      <div class="bodyBox">
        <contactUsComponent/>
      </div>
    </div>
    <div class="footClass">
      <div class="bodyBox">
        <footComponent/>
      </div>
    </div>
  </div>
</template>

<script>
import Bus from '../bus.js'
import companyProfile from '../components/companyProfile.vue'
import companyGood from '../components/companyGood.vue'
// import swiperIntroduction from '../components/swiperIntroduction.vue'
// import teamIntroduction from '../components/teamIntroduction.vue'
import footComponent from '../components/footComponent.vue'
import contactUsComponent from '../components/contactUsComponent.vue'
export default {
  components:{
    companyProfile,
    companyGood,
    // swiperIntroduction,
    // teamIntroduction,
    footComponent,
    contactUsComponent
  },
  data() {
    return {};
  },
  methods:{
    handleJump(e ,data) {
      try{
        document.documentElement.scrollTop = 0
        if (e == "7") {
          // console.log(this.$refs.pmpe.getBoundingClientRect())
          window.scrollTo({
              top:1,
              behavior: "smooth"
          })
        }
        if (e == "8" && this.$refs.cc.getBoundingClientRect().top !== 0) {
          // document.documentElement.scrollTop =
          //   this.$refs.pmpp.getBoundingClientRect().top;
          window.scrollTo({
              top:this.$refs.cc.getBoundingClientRect().top-50,
              behavior: "smooth"
          })
        }
      }catch(err){

      }
    },
  },
  mounted(){
    Bus.$on("jump", (data) => {
      this.handleJump(data,1)
    });
    this.handleJump(this.$route.query.jump,2)
  }
};
</script>

<style lang="scss" scoped>
.about-container {
  .contactusClass{
    background:url('../assets/pageImg/companyProfile.jpg') no-repeat center;
    background-size:cover;
    background-position: top;
  }
  .swiperIntroduction-box{
    background:url('../assets/pageImg/historyBackground.jpg') no-repeat center;
    background-size:cover;
    background-position: top;
  }
  .footClass{
    background: #1B1C1D;
  }
  .contactUsComponent-class{
    background:url('../assets/pageImg/contentUsBackground.jpg') no-repeat center;
    background-size:cover;
    background-position: top;
  }
}
.bodyBox {
  max-width: 1240px;
  margin: auto;
  padding: 0px 20px;
  box-sizing: border-box;
}

@media screen and (max-width: 767px) {
  .about-container {
  }
  .bodyBox {
    padding: 0px 10px;
  }
}
</style>